"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var CheckIcon_1 = __importDefault(require("../common/FirstSection/CheckIcon"));
var styles_1 = require("../common/styles");
var List_1 = __importDefault(require("../common/List"));
var cup1_webp_1 = __importDefault(require("./assets/cup1.webp"));
var cup2_png_1 = __importDefault(require("./assets/cup2.png"));
var cup3_png_1 = __importDefault(require("./assets/cup3.png"));
var cup4_png_1 = __importDefault(require("./assets/cup4.png"));
var cup5_png_1 = __importDefault(require("./assets/cup5.png"));
var cup6_png_1 = __importDefault(require("./assets/cup6.png"));
var cup7_png_1 = __importDefault(require("./assets/cup7.png"));
var cup8_png_1 = __importDefault(require("./assets/cup8.png"));
var cup9_png_1 = __importDefault(require("./assets/cup9.png"));
var cup10_png_1 = __importDefault(require("./assets/cup10.png"));
var cup11_png_1 = __importDefault(require("./assets/cup11.png"));
var cup12_png_1 = __importDefault(require("./assets/cup12.png"));
var bg_png_1 = __importDefault(require("./FirstSection/bg.png"));
exports.default = {
    bgimageStyle: "\n        max-width: 840px;\n        top: -10px;\n        right: -70px;\n    ",
    FirstSectionBgImage: bg_png_1.default,
    axiosLink: '/api/products/mug?format=json',
    productLink: '/mugs/new_v2',
    productNamePlural: 'кружки',
    seoText: (react_1.default.createElement(styles_1.Text, null, "\u0412\u0441\u0435\u0433\u0434\u0430 \u043C\u043E\u0436\u043D\u043E \u043A\u0443\u043F\u0438\u0442\u044C \u043A\u0440\u0443\u0436\u043A\u0443 \u0441 \u043F\u0440\u0438\u043D\u0442\u043E\u043C \u0432 \u043C\u0430\u0433\u0430\u0437\u0438\u043D\u0435 \u2014 \u043D\u043E \u044D\u0442\u043E \u0431\u0443\u0434\u0435\u0442 \u0441\u0435\u0440\u0438\u0439\u043D\u043E\u0435 \u043F\u0440\u043E\u0438\u0437\u0432\u043E\u0434\u0441\u0442\u0432\u043E, \u043A\u043E\u0442\u043E\u0440\u043E\u0435 \u043E\u0440\u0438\u0435\u043D\u0442\u0438\u0440\u0443\u0435\u0442\u0441\u044F \u043D\u0430 \u0438\u043D\u0442\u0435\u0440\u0435\u0441\u044B \u043C\u0430\u0441\u0441. \u0417\u0430\u043A\u0430\u0437 \u043C\u043E\u0434\u0435\u043B\u0438 \u0441 \u0438\u043D\u0434\u0438\u0432\u0438\u0434\u0443\u0430\u043B\u044C\u043D\u044B\u043C \u0434\u0438\u0437\u0430\u0439\u043D\u043E\u043C \u0434\u0430\u0435\u0442 \u043F\u0440\u043E\u0441\u0442\u043E\u0440 \u0432\u0430\u0448\u0435\u043C\u0443 \u0432\u043E\u043E\u0431\u0440\u0430\u0436\u0435\u043D\u0438\u044E. \u041B\u044E\u0431\u044B\u0435 \u043A\u0440\u0430\u0441\u043A\u0438, \u0442\u0435\u043C\u0430\u0442\u0438\u0447\u0435\u0441\u043A\u0438\u0435 \u0441\u044E\u0436\u0435\u0442\u044B, \u0430\u0431\u0441\u0442\u0440\u0430\u043A\u0442\u043D\u044B\u0435 \u043F\u0440\u0438\u043D\u0442\u044B, \u043B\u043E\u0433\u043E\u0442\u0438\u043F\u044B \u0441\u043F\u043E\u043D\u0441\u043E\u0440\u043E\u0432 \u2013 \u0442\u0430\u043A\u0430\u044F \u043A\u0440\u0443\u0436\u043A\u0430 \u0431\u0443\u0434\u0435\u0442 \u0442\u043E\u043B\u044C\u043A\u043E \u0443 \u0432\u0430\u0441. \u041C\u043E\u0434\u0435\u043B\u0438\u0440\u0443\u0439\u0442\u0435 \u043E\u0434\u0435\u0436\u0434\u0443 \u0441\u0430\u043C\u043E\u0441\u0442\u043E\u044F\u0442\u0435\u043B\u044C\u043D\u043E \u0438\u043B\u0438 \u0432\u043E\u0441\u043F\u043E\u043B\u044C\u0437\u0443\u0439\u0442\u0435\u0441\u044C \u043A\u043E\u043D\u0441\u0443\u043B\u044C\u0442\u0430\u0446\u0438\u0435\u0439 \u043D\u0430\u0448\u0438\u0445 \u0434\u0438\u0437\u0430\u0439\u043D\u0435\u0440\u043E\u0432 \u0434\u043B\u044F \u0441\u043E\u0441\u0442\u0430\u0432\u043B\u0435\u043D\u0438\u044F \u043C\u0430\u043A\u0435\u0442\u0430 \u043F\u0440\u0438\u043D\u0442\u0430.")),
    firstSectionTitle: (react_1.default.createElement(styles_1.MainTitle, null,
        "\u041F\u0435\u0447\u0430\u0442\u044C \u043D\u0430 \u043A\u0440\u0443\u0436\u043A\u0430\u0445",
        react_1.default.createElement("br", null),
        " \u043D\u0430 \u0437\u0430\u043A\u0430\u0437")),
    firstSectionText: (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(styles_1.Text, null,
            "\u041D\u0430 \u043A\u0435\u0440\u0430\u043C\u0438\u0447\u0435\u0441\u043A\u0443\u044E \u043A\u0440\u0443\u0436\u043A\u0443 \u043C\u043E\u0436\u043D\u043E \u043F\u0435\u0440\u0435\u043D\u0435\u0441\u0442\u0438 \u043B\u044E\u0431\u0443\u044E \u043D\u0430\u0434\u043F\u0438\u0441\u044C ",
            react_1.default.createElement("br", null),
            "\u0438\u043B\u0438 \u0438\u0437\u043E\u0431\u0440\u0430\u0436\u0435\u043D\u0438\u0435. \u041F\u043E\u0434\u043E\u0431\u043D\u044B\u0439 \u0441\u0443\u0432\u0435\u043D\u0438\u0440 \u0441\u0442\u0430\u043D\u0435\u0442 \u043E\u0442\u043B\u0438\u0447\u043D\u044B\u043C \u043F\u043E\u0434\u0430\u0440\u043A\u043E\u043C ",
            react_1.default.createElement("br", null),
            "\u043A\u043E\u043B\u043B\u0435\u0433\u0435 \u043F\u043E \u0440\u0430\u0431\u043E\u0442\u0435, \u0431\u043B\u0438\u0437\u043A\u043E\u043C\u0443 \u0447\u0435\u043B\u043E\u0432\u0435\u043A\u0443."),
        react_1.default.createElement(List_1.default, { icon: react_1.default.createElement(CheckIcon_1.default, null) },
            react_1.default.createElement(styles_1.Text, null, "\u041A\u043E\u0440\u043F\u043E\u0440\u0430\u0442\u0438\u0432\u043D\u0430\u044F \u043E\u0434\u0435\u0436\u0434\u0430 \u0438 \u0441\u0443\u0432\u0435\u043D\u0438\u0440\u044B \u043F\u043E\u0434 \u043A\u043B\u044E\u0447"),
            react_1.default.createElement(styles_1.Text, null, "\u041F\u043E\u043C\u043E\u0449\u044C \u0434\u0438\u0437\u0430\u0439\u043D\u0435\u0440\u0430"),
            react_1.default.createElement(styles_1.Text, null, "\u0418\u0437\u0433\u043E\u0442\u043E\u0432\u043B\u0435\u043D\u0438\u0435 \u0432 \u0434\u0435\u043D\u044C \u043E\u0431\u0440\u0430\u0449\u0435\u043D\u0438\u044F"),
            react_1.default.createElement(styles_1.Text, null, "\u0428\u0438\u0440\u043E\u043A\u0438\u0439 \u0432\u044B\u0431\u043E\u0440 \u043A\u0440\u0443\u0436\u0435\u043A: \u043E\u0442 \u043E\u0431\u044B\u0447\u043D\u044B\u0445 \u0434\u043E \u0442\u0435\u0440\u043C\u043E\u043A\u0440\u0443\u0436\u0435\u043A")))),
    productsTitle: 'Кружки для нанесения',
    products: [
        {
            link: '/full_print_mugs/new_v2',
            image: cup1_webp_1.default,
            text: '3D кружка',
        },
        {
            link: '/mugs/new_v2',
            image: cup2_png_1.default,
            text: 'Кружка',
        },
        {
            link: '/colored_handle_mugs/new_v2',
            image: cup3_png_1.default,
            text: 'Кружка с цветной ручкой и ободком',
        },
        {
            link: '/colored_inside_mugs/new_v2',
            image: cup4_png_1.default,
            text: 'Кружка цветная внутри',
        },
        {
            link: '/beer_mugs/new_v2',
            image: cup5_png_1.default,
            text: 'Пивная кружка',
        },
        {
            link: '/metal_bottles/new_v2',
            image: cup6_png_1.default,
            text: 'Металлическая бутылка',
        },
        {
            link: '/sport_bottles/new_v2',
            image: cup7_png_1.default,
            text: 'Спортивная бутылка',
        },
        {
            link: '/plastic_bottles/new_v2',
            image: cup8_png_1.default,
            text: 'Прозрачная бутылка',
        },
        {
            link: '/suction_thermo_mugs/new_v2',
            image: cup9_png_1.default,
            text: 'Термокружка на присоске',
        },
        {
            link: '/thermo_mugs/new_v2',
            image: cup10_png_1.default,
            text: 'Термокружка',
        },
        {
            link: '/thermoses/new_v2',
            image: cup11_png_1.default,
            text: 'Термос',
        },
        {
            link: '/cans/new_v2',
            image: cup12_png_1.default,
            text: 'Банка',
        },
    ]
};
